import { render, staticRenderFns } from "./cuponesList.vue?vue&type=template&id=dc13d55a&scoped=true&"
import script from "./cuponesList.vue?vue&type=script&lang=js&"
export * from "./cuponesList.vue?vue&type=script&lang=js&"
import style0 from "./cuponesList.vue?vue&type=style&index=0&id=dc13d55a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13d55a",
  null
  
)

export default component.exports